import * as React from 'react';

import { pluralize } from '@acceligentllc/shared/utils/pluralization';

import Tooltip from 'af-components/Tooltip';

import styles from './styles.module.scss';

interface OwnProps {
	type: 'added' | 'removed';
	count: number;
}

type Props = OwnProps;

const DiffCount: React.FC<Props> = (props) => {
	const { type, count } = props;

	const isAdded = type === 'added';

	const prefixSymbol = isAdded ? '+' : '-';

	const resolvedClassName = `${styles.DiffCount} ${styles[type]}`;

	const titlePrefix = isAdded ? 'Added' : 'Removed';

	const message = React.useMemo(() => {
		return (
			<div className={styles.tooltipMessage}>
				<div><b>{titlePrefix} {pluralize(count, ['a Material', 'Materials'])}</b></div>
				<div>{count} {pluralize(count, ['material has', 'materials have'])} been {isAdded ? 'added' : 'removed'} {isAdded ? 'to' : 'from'} the selection.</div>
			</div>
		);
	}, [count, isAdded, titlePrefix]);

	if (count === 0) {
		return null;
	}

	return (
		<Tooltip containerClassName={resolvedClassName} message={message}>
			<div>{prefixSymbol}{count}</div>
		</Tooltip>
	);
};

export default React.memo(DiffCount);
